import * as React from 'react';
import { AppLayoutSettings } from '../common.styles';
import { IStyleFunctionOrObject, IMessageBarStyleProps, IMessageBarStyles } from 'office-ui-fabric-react'

export const getRecordingContainerStyles = (): React.CSSProperties => {
  return {
    marginTop: '110px'
  };
};

export const getWarningMessageBarStyles = (): React.CSSProperties => {
  return {
    position: "absolute",
    bottom: 0
  }
}

export const getPrivacyDisclaimerStyles = (): IStyleFunctionOrObject<IMessageBarStyleProps, IMessageBarStyles> => {
  return {
    // Show no icon in the privacy disclaimer
    icon: {
      display: 'none',
    },

    root: {
      background: AppLayoutSettings.AppColors.lightBlue
    }
  }
}

export const getPrivacyDisclaimerTextStyles = () => {
  return {
    root: {
      color: AppLayoutSettings.AppColors.whiteColor,

      // Since the privacy disclaimer is white text on dark background, we need to make sure a dark high contrast color is shown when in white theme.
      selectors: {
        ['@media screen and (-ms-high-contrast: black-on-white)']: {
          color: 'windowText'
        }
      }
    }
  }
}

export const getPrivacyPolicyLinkStyle = (): React.CSSProperties => {
  return {
    color: AppLayoutSettings.AppColors.whiteColor,
    textDecoration: 'underline'
  }
}